import * as React from 'react';
import * as _ from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { SectionWrapper } from 'common/baseComponents';
import { ImageHeaderContainer, MainImageContainer, SecondaryImageContainer, ThridImageContainer, DisclaimerBanner, Image } from './ImageHeaderStyles';
import { serviceLoading } from 'common/loaderReducer';
import Loader from 'components/Loader';
import { SeparatorW } from 'features/Dealers/DealerConfiguration/styles';
import { FieldSection } from 'features/Dealers/Listings/GMBPreview/FieldSection';
import { getDealerEnginePreview } from 'features/Dealers/Listings/GMBPreview/state/actions';
import { GET_DEALER_ENGINE_PREVIEW_API_REQUEST } from 'features/Dealers/Listings/GMBPreview/state/actionTypes';

const ImageHeader = () => {
    const {
        preview,
        dealerId,
        isLoading,
    } = useSelector((rootState: RootState) => {
        return {
            preview: rootState.dealers.listing.currentListing.enginePreview.gmbPreview,
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            isLoading: serviceLoading(rootState, [GET_DEALER_ENGINE_PREVIEW_API_REQUEST]),
        }
    }, shallowEqual);

    const imageURLS = React.useMemo(() => {
        const urls = ["", "", ""];
        if (preview?.urlImages) {
            let lastUrl = ""
            urls.forEach((_, idx) => {
                urls[idx] = preview.urlImages.length >= idx + 1 ? preview.urlImages[idx] : ""
            });
        }
        return urls;
    }, [preview])

    if (preview) {
        return (
            <ImageHeaderContainer>
                <MainImageContainer>
                    <Image src={imageURLS[0]} />
                </MainImageContainer>
                <SecondaryImageContainer>
                    <Image src={imageURLS[1]} />
                </SecondaryImageContainer>
                <ThridImageContainer>
                    <Image src={imageURLS[2]} />
                </ThridImageContainer>
                <DisclaimerBanner>
                    {
                        "Images are not representative of search results"
                    }
                </DisclaimerBanner>
            </ImageHeaderContainer>
        )
    }
    return (<div>error</div>)

}


export default ImageHeader